






























import { defineComponent } from '@vue/composition-api';

const name = 'ttam-material-cover';

export default defineComponent({
  name,

  props: {
    index: { type: Number, default: -1 },
    coverUrl: { type: String, default: '' },
    materialInfo: { type: Object, default: () => ({}) },
    isShowVideoPlayIcon: { type: Boolean, default: true },
  },

  setup() {
    return { name };
  },
});
